<template>
  <div class="initiative">
    <h1 style="font-weight:700;">開放取用(Open Access)簡介</h1>
    <p class="txt" style="text-align: center;">原作者：Peter Suber (<a href="http://legacy.earlham.edu/~peters/fos/brief.htm">http://legacy.earlham.edu/~peters/fos/brief.htm</a>)</p>
    <p class="txt">開放取用(Open Access, OA)論文是指以一種數位形式公開於線上、免費且不受著作權和授權限制的文獻。開放取用立基於網際網路的蓬勃發展之下，因作者或著作權持有者同意開放而促成。</p>
    <p class="txt">開放取用與同儕審查可以並行不悖，且所有推廣科學及學術文獻開放取用的倡議者都堅持同儕審查的重要性。如同期刊論文作者所付出的努力，許多期刊編輯及參與同儕審查者也貢獻了許多心力。</p>
    <p class="txt">雖然相較於傳統期刊的出版花費較少，但開放取用文獻的產生並非毫無成本。當中的問題不在於學術文獻能否零成本產出，而是除了向讀者收費和設立取用障礙外，是否有更好的方式來維運內容資料。當前推動開放取用的策略將與採用何種商業模式來支付相關費用有所關連。</p>
    <br><br>
    <h1 style="font-weight:700;">推動研究論文開放取用的兩大工具：開放取用期刊及開放取用典藏庫</h1>
    <h2 style="font-weight:500;">開放取用期刊（OA Journals）</h2>
    <p class="txt">開放取用期刊採用同儕審查制度，將審查通過的內容免費提供給全世界取用。開放期刊所需的花費包含同儕審查、原稿編輯，以及伺服器維運之軟硬體成本。</p>
    <p class="txt">開放取用期刊支付費用的方式與傳統傳播電視廣播電台非常相似，對於傳播內容有興趣的人預先支付生產成本，讓所有人可以透過適當的設備免費取用。期刊可能受到所屬大學或專業學術團體的補助；或可能向論文的作者收取文章處理費（Article Processing Charge, APC），這筆費用一般由作者本人或作者的資助人（如雇主、補助機構）等支付。</p>
    <p class="txt">受機構補助的開放取用期刊傾向不收取處理費用；而收取文章處理費的開放取用期刊，通常能夠提供經濟上有困難的作者優惠價格。</p>
    <p class="txt">若是開放取用期刊有其他收入來源，例如：其他出版刊物、廣告、付費服務或補助服務等，通常尚且能夠勉強仰賴較低額度的補助費或文章處理費生存。部分開開放取用期刊對於機構和聯盟給予文章處理費折扣，部分開放取用期刊免除已支付年費之機構內研究者需支付的文章處理費。然而如何支付同儕審查之開放取用期刊的文章處理費仍有很大的討論空間，目前我們可以盡量具有發揮各自的才智和想像力。</p>
    <br>
    <h2 style="font-weight:500;">開放取用典藏庫（OA Archives or Repositories）</h2>
    <p class="txt">開放取用典藏庫並不進行同儕審查，而是直接將作者的內容免費提供給大眾。開放取用典藏庫中可能會有許多未經審查的預刊本（preprint）、經審查後的作者定稿本（postprint），或者兩者兼具。</p>
    <p class="txt">典藏庫可能隸屬於機構之下，例如大學、實驗室，此類典藏庫一般稱為機構典藏（Institutional Repositories)；或者是跨機構、以學科領域為基礎，例如：物理學和經濟學之下。</p>
    <p class="txt">論文作者可能不需經過他人的同意，便得以典藏他們的預刊本，且大部分的期刊都已經同意作者能夠典藏他們的作者定稿本。當典藏庫遵守OAI-PMH的詮釋資料收割機制時，典藏庫彼此間便能互通，甚至可以透過Google Scholar等檢索引擎搜尋到全球開放取用典藏庫的內容，如此一來自然增加論文的能見度和影響力。</p>
    <p class="txt" style="text-indent: 0em">資料來源：<a href="https://st6.ning.com/topology/rest/1.0/file/get/2865285005?profile=original">https://st6.ning.com/topology/rest/1.0/file/get/2865285005?profile=original</a></p>
  </div>
</template>
<script>
export default {
  name: 'Initiative'
}

</script>
<style>
/*@font-face {
  font-family: Times New Roman;
  src: url(DroidSans.woff);
  unicode-range: U+000-5FF, U+1e00-1fff, U+2000-2300;
}*/


.initiative {
  padding: 4%;
  padding-top: 2%;
  background-color: rgba(248, 194, 88,0.1);
  box-shadow: 0 5px 5px -2px rgba(0, 0, 0, .2);
  padding-bottom: 50px;

}

h1 {
  font-weight: 700;
}

h2 {
  font-weight: 700;
}

.txt {


  font-size: 20px;
  text-align: left;
  text-indent: 2em;
  font-weight: 500;

}

</style>
